import { useMediaQuery, useTheme } from '@mui/material';
import { useCallback, useState } from 'react';

const GAP = 24;
const GAP_SM = 16;

const getSlidesPerView = ({ md, xl }) => {
  if (md) return 1;
  if (xl) return 2;
  return 3;
};

export const useCarousel = (slideCount, options = {}) => {
  const theme = useTheme();
  const isMd = useMediaQuery(theme.breakpoints.down('md'));
  const isXl = useMediaQuery(theme.breakpoints.down('xl'));
  const slidesPerView =
    options.slidesPerView ?? getSlidesPerView({ md: isMd, xl: isXl });
  const gap = isMd ? GAP_SM : GAP;

  const [selectedIndex, setSelectedIndex] = useState(0);
  const maxIndex = Math.max(0, slideCount - slidesPerView);
  const activeIndex = Math.min(selectedIndex, maxIndex);

  const scrollPrev = useCallback(() => {
    setSelectedIndex((index) => Math.max(0, Math.min(index, maxIndex) - 1));
  }, [maxIndex]);

  const scrollNext = useCallback(() => {
    setSelectedIndex((index) =>
      Math.min(maxIndex, Math.min(index, maxIndex) + 1),
    );
  }, [maxIndex]);

  const slideWidth = `((100% - ${(slidesPerView - 1) * gap}px) / ${slidesPerView})`;
  const offset = `calc(-${activeIndex} * (${slideWidth} + ${gap}px))`;

  return {
    selectedIndex: activeIndex,
    slidesPerView,
    gap,
    offset,
    scrollPrev,
    scrollNext,
    canScrollPrev: activeIndex > 0,
    canScrollNext: activeIndex < maxIndex,
  };
};
